import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function myJobsReducer(state = initialState.myJobs, action) {
  switch (action.type) {
    case types.LOAD_MY_JOBS_SUCCESS:
      return action.myJobs;

    default:
      return state;
  }
}
